import React from 'react';
import { BrowserRouter } from "react-router-dom";
import AuthDataProvider from "./components/AuthDataProvider";
import Layout from "./components/Layout";
import Router from "./Routes";
import './App.css';

function App() {

  return (
    <BrowserRouter>
      <AuthDataProvider>
        <Layout>
          <Router />
        </Layout>
      </AuthDataProvider>
    </BrowserRouter>
  );
}

export default App;
